
















































































import { Vue, Component, Inject } from "vue-property-decorator";

// Types
import {
  IUsersProviderData,
  IUsersProviderMethods
} from "@/models/providers/users";

@Component({
  components: {
    "api-token-list-item": () =>
      import("@/components/app/admin/users/apiTokenListItem.vue")
  }
})
export default class ApiTokenList extends Vue {
  // Inject

  @Inject({ from: "usersProviderData" })
  public readonly $usersProviderData!: () => IUsersProviderData;

  @Inject({ from: "usersProviderMethods" })
  public readonly $usersMethods!: IUsersProviderMethods;

  // Computed

  public get $usersData() {
    return this.$usersProviderData();
  }

  public get isLoading() {
    return this.$usersData.isLoading || this.$usersData.isReloading;
  }

  public get showSkeletons() {
    return this.isLoading || !this.$usersData.total;
  }

  public get skeletonSize() {
    return (
      this.$usersData.total || (this.$store.getters["ui/isMobile"] ? 2 : 5)
    );
  }
}
